import { FC, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getTaskLlmInfo } from 'src/api/tasks';
import { RoutesEnum } from 'src/types/navigation';
import LlmInfoView from './components/LlmInfoView';

type Params = { id: string };

const TaskLlmInfoPage: FC = () => {
    const { id } = useParams<Params>();
    const fetchSessions = useCallback(
        () => (id ? getTaskLlmInfo(id) : Promise.resolve({ data: [] })),
        [id]
    );

    return (
        <LlmInfoView
            title={`LLM info for task ${id ?? ''}`}
            backTo={RoutesEnum.TASK_DETAIL.replace(':id', id ?? '')}
            fetchSessions={fetchSessions}
        />
    );
};

export default TaskLlmInfoPage;
